// Search params that are reused across multiple pages
export const SHARED_SEARCH_PARAMS = {
  backLabel: 'backLabel',
  backUrl: 'backUrl',
  scrollY: 'scrollY',
}

// Page-specific search params
export const SEARCH_PARAMS = {
  addRelationshipAgreement: {
    referralDirection: 'referralDirection',
    returnPath: 'returnPath',
  },
  help: {
    backLabel: SHARED_SEARCH_PARAMS.backLabel,
    backUrl: SHARED_SEARCH_PARAMS.backUrl,
  },
  challenge: {
    redirectUri: 'redirectUri',
  },
  clientReferralSettings: {
    pageContentTab: 'pageContentTab',
    lastSavedAt: 'lastSavedAt',
  },
  clients: {
    clientId: 'clientId',
  },
  companyProfile: {
    backLabel: SHARED_SEARCH_PARAMS.backLabel,
    backUrl: SHARED_SEARCH_PARAMS.backUrl,
    hasJustAddedRelationship: 'hasJustAddedRelationship',
    hasSentFirstInvite: 'hasSentFirstInvite',
    identifier: 'identifier',
    identifierType: 'identifierType',
    profileTab: 'profileTab',
    searchTerm: 'searchTerm',
    isShowingEmbedReferralFormDialog: 'isShowingEmbedReferralFormDialog',
    isShowingShareReferralFormDialog: 'isShowingShareReferralFormDialog',
  },
  companyCompass: {
    step: 'step',
    clientId: 'clientId',
    referralId: 'referralId',
    token: 'token',
  },
  companyCompassView: {
    token: 'token',
    step: 'step',
  },
  companyCompassInvite: {
    shouldSkipPreviewMode: 'shouldSkipPreviewMode',
    hasConfirmedSharing: 'hasConfirmedSharing',
  },
  commercialAgreementEdit: {
    returnPath: 'returnPath',
  },
  commercialAgreementTemplateReview: {
    step: 'step',
    mode: 'mode',
    revisionId: 'revisionId',
  },
  compassSnapshot: {
    step: 'step',
  },
  companyCompassSnapshots: {
    compassSnapshotModalToken: 'compassSnapshotModalToken',
    compassSnapshotModalTab: 'compassSnapshotModalTab',
  },
  compassPdfReportPreview: {
    token: 'token',
    accessToken: 'accessToken',
    browserlessKey: 'browserlessKey',
  },
  compassPdfReportSection: {
    token: 'token',
  },
  compassRedirect: {
    // The absolute URL to redirect to after the user logs in or registers.
    returnUrl: 'returnUrl',

    reportToPrefetch: 'reportToPrefetch',

    // If the user verified their date of birth, we'll reuse their input so that
    // they don't have to re-verify after logging in or registering.
    accessToken: 'accessToken',
  },
  debug: {
    commercialAgreementTemplateId: 'commercialAgreementTemplateId',
  },
  directLeadCaptureSettings: {
    isShowingEmbedCodeDialog: 'isShowingEmbedCodeDialog',
    isShowingShareFormDialog: 'isShowingShareFormDialog',
  },
  manageLocations: {
    page: 'page',
  },
  manageUsers: {
    showInviteModal: 'showInviteModal',
  },
  professionalNetworkRelationships: {
    hasSentFirstInvite: 'hasSentFirstInvite',
    identifier: 'identifier',
    identifierType: 'identifierType',
    profileTab: 'profileTab',
    companyName: 'companyName',
    location: 'location',
    panelStatus: 'panelStatus',
    recommendedPartnerId: 'recommendedPartnerId',
  },
  redirect: {
    redirectTo: 'redirectTo',
  },
  referClient: {
    clientId: 'clientId',
    companyTypeCode: 'companyTypeCode',
    consentType: 'consentType',
    isReferringToAdviserEmail: 'isReferringToAdviserEmail',
    referralFirmId: 'referralFirmId',
    referralFirmIndividuals: 'referralFirmIndividuals',
    referralMethod: 'referralMethod',
    referralTypeOption: 'referralTypeOption',
    serviceAreaIds: 'serviceAreaIds',
    shouldAttachLatestCompassReport: 'shouldAttachLatestCompassReport',
    step: 'step',
    lockToClient: 'lockToClient',
  },
  referralESignatureConsentPdf: {
    clientName: 'clientName',
    consentStage: 'consentStage',
    consentLetterVariant: 'consentLetterVariant',
  },
  referralESignatureConsentPdfPreview: {
    clientId: 'clientId',
    otherCompanyId: 'otherCompanyId',
    consentLetterVariant: 'consentLetterVariant',
    consentStage: 'consentStage',
    serviceAreaIds: 'serviceAreaIds',
    eSignatureTab: 'eSignatureTab',
  },
  referrals: {
    clientId: 'clientId',
    pageSize: 'pageSize',
    referralLinkCode: 'referralLinkCode',
    tab: 'tab',
    columns: 'columns',
    columnOrder: 'columnOrder',
    view: 'view',
    selectedReferralId: 'selectedReferralId',
    directLeadCaptureSettings: 'directLeadCaptureSettings',
  },
  referralSummary: {
    backLabel: SHARED_SEARCH_PARAMS.backLabel,
    backUrl: SHARED_SEARCH_PARAMS.backUrl,
  },
  requestCallback: {
    hasJustGivenConsent: 'hasJustGivenConsent',
  },
  signIn: {
    token: 'token',
    redirectUri: 'redirectUri',
  },
  signOut: {
    redirectUri: 'redirectUri',
  },
  signUp: {
    redirectUri: 'redirectUri',
  },
  userCompass: {
    // Set when user is redirected via company global link and only used for
    // analytics purposes
    companyReferralCode: 'companyReferralCode',
    compassReportId: 'compassReportId',
    clientId: 'clientId',
    referralId: 'referralId',
    token: 'token',
    step: 'step',
    willShareWithClient: 'willShareWithClient',
    inviteClientsTab: 'inviteClientsTab',
    returnUrl: 'returnUrl',
    withCompany: 'withCompany',
    backUrl: 'backUrl',
  },
}
